// extracted by mini-css-extract-plugin
module.exports = {"row":"_4a896a44","loginWell":"_91d79b9f","disclaimerWell":"_8a99cebf","diclaimerContainer":"_5ae99079","disclaimerContentContainer":"_2c5898c3","disclaimerCloseButton":"_c6e9450d"};